import { ConnectionQuality } from 'livekit-client'

/**
 * Overall network state tracked by useLiveKit
 */
export interface NetworkState {
  /** Local user's connection quality */
  localQuality: ConnectionQuality
  /** Remote agent's connection quality (null if agent not in room) */
  agentQuality: ConnectionQuality | null
  /** Whether the agent is currently in the room */
  isAgentConnected: boolean
  /** Whether a reconnection attempt is in progress */
  isReconnecting: boolean
}

/**
 * Display-friendly quality level
 */
export type QualityLevel = 'excellent' | 'good' | 'poor' | 'lost' | 'unknown'

/**
 * Maps ConnectionQuality enum to display-friendly quality level
 */
export function toQualityLevel(quality: ConnectionQuality): QualityLevel {
  switch (quality) {
    case ConnectionQuality.Excellent:
      return 'excellent'
    case ConnectionQuality.Good:
      return 'good'
    case ConnectionQuality.Poor:
      return 'poor'
    case ConnectionQuality.Lost:
      return 'lost'
    default:
      return 'unknown'
  }
}
